export const BEAUTIFY_OPTS = {
  indent_size: 2,
  indent_char: '\x20',
  other: '\x20',
  indent_level: 0x0,
  indent_with_tabs: false,
  preserve_newlines: true,
  max_preserve_newlines: 0x2,
  jslint_happy: true,
  indent_handlebars: true
};

export const SUPPORTED_PARSERS = new Set(['babel', 'html', 'php']);

export const LANGUAGE_FORMATTER = {
  js: 'babel',
  jsx: 'babel',
  html: 'html',
  // csharp: 'csharp',
  // dotnet: 'csharp',
  // java: 'java',
  php: 'php'
};
